import { footerData, siteName } from '@/mocks/comicData';

export default function Footer() {
  return (
    <footer id="footer" className="bg-background-900 text-background-200 pt-14 md:pt-20 pb-8 px-4 md:px-6">
      <div className="max-w-[1280px] mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 mb-12">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500">
                <i className="ri-book-open-line text-background-50 text-sm"></i>
              </div>
              <span className="text-lg font-heading font-bold text-background-50">
                {siteName}
              </span>
            </div>
            <p className="text-xs md:text-sm text-background-400 leading-relaxed">
              {footerData.intro}
            </p>
          </div>

          <div>
            <h4 className="text-sm font-heading font-semibold text-background-50 mb-4">快速链接</h4>
            <div className="grid grid-cols-2 gap-2">
              {footerData.links.map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  className="text-xs md:text-sm text-background-400 hover:text-background-100 transition-colors whitespace-nowrap cursor-pointer"
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-heading font-semibold text-background-50 mb-4">合作伙伴</h4>
            <p className="text-xs text-background-500 leading-relaxed">
              古古漫画网期待与更多优质漫画平台、创作者和内容提供方建立合作，共同为漫迷打造更好的阅读体验。
            </p>
          </div>
        </div>

        <div className="border-t border-background-700/50 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-500">{footerData.copyright}</p>
          <p className="text-xs text-background-600">
            本站所有漫画内容均来自网络公开资源，仅供学习交流使用
          </p>
        </div>
      </div>
    </footer>
  );
}